import * as React from "react";
import {HomeWelcomeVideo} from '../../component/home/HomeWelcomeVideo';
import {Navigation} from '../../component/layout/Navigation';
import {HomeHistory} from '../../component/home/HomeHistory';
import {HomeAbout} from '../../component/home/HomeAbout';
import {HomeNews} from '../../component/home/HomeNews';
import {Footer} from '../../component/layout/Footer';
import {IReadPostResponse} from "../../core/api/post/response/ReadPostResponse";
import {PostApiService} from "../../core/api/post/PostApiService";
import {CoreConstant} from "../../core/utility/CoreConstant";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";

interface IProps {
    componentName?: string;
}

interface IState{
    isLoading: boolean;
    aboutData: IReadPostResponse[] | undefined;
    newsData: IReadNewsResponse[] | undefined;
}

export class Home extends React.Component<IProps, IState> {

    private readonly postService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: true,
            aboutData: undefined,
            newsData: undefined
        }
    }

    public componentDidMount = () => {
        this.readVillageData();
        this.getLatestNews();
    };

    public render() {
        return (
            <div id="home-page" className="client-area">
                <div id="top" className="page">
                    <HomeWelcomeVideo />
                    <Navigation navClass="main-nav dark transparent stick-fixed" isHideLogo={true} />
                    {!this.state.isLoading && this.state.aboutData !== undefined && (
                        <div>
                            <HomeHistory data={this.state.aboutData.filter(item => item.tag === 'sejarah')[0]} />
                            <hr className="mt-0 mb-0 " />
                            <HomeAbout data={this.state.aboutData.filter(item => item.tag === 'gambaran-umum' || item.tag === 'visi' || item.tag === 'misi')} />
                        </div>
                    )}
                    
                    <section className="page-section pt-0 pb-0 banner-section bg-dark">
                        <div className="container relative">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="mt-140 mt-lg-80 mb-140 mb-lg-80">
                                        <div className="banner-content">
                                            <h3 className="banner-heading font-alt">Sistem Informasi Geografis</h3>
                                            <div className="banner-decription">
                                                deskripsi singkat SIG
                                            </div>
                                            <div className="local-scroll">
                                                <a className="btn btn-mod btn-w btn-medium btn-round"
                                                    href="http://gis.sanurkauh.desa.id">
                                                    KUNJUNGI APLIKASI GISAKA
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 banner-image wow fadeInUp">
                                    <img src="asset/image/promo-1.png" alt="image" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="page-section">
                        <div className="container relative">
                            <div className="row alt-features-grid">
                                <div className="col-sm-3">
                                    <div className="alt-features-item align-center">
                                        <div className="alt-features-descr align-left">
                                            <h4 className="mt-0 font-alt">Layanan Utama Website</h4>
                                                Sistem Informasi Desa Sanur Kauh memiliki beberapa layanan utama bla bla bla
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-9">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Aspirasi Online</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Pengaduan Online</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Sistem Informasi Geografis</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Berita Terbaru</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Pengumuman-Pengumuman</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Agenda Desa</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Informasi Dusun</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Informasi STT, PKK</h3>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="alt-features-item align-center">
                                                <h3 className="alt-features-title font-alt">Informasi Organisasi Desa</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {this.state.newsData === undefined ? <p>loading ...</p> : <HomeNews data={this.state.newsData} />}

                    <Footer />
                </div>
            </div>
        );
    }

    private readVillageData = () =>{
        this.postService.getByCategory(CoreConstant.PostCategory.About)
            .then((response: any) => {
                this.setState({
                    isLoading: false,
                    aboutData: response.result
                })
            })
    };

    private getLatestNews = () =>{
        this.postService.getNews(3)
            .then((response: any) => {
                this.setState({
                    newsData: response.result
                })
            }).catch((error) => {
            this.setState({
                newsData: []
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/screen/home/Home.tsx